import React, { FC, useState } from 'react';
import { Slider as MaterialSlider, withStyles } from '@material-ui/core';
import styled from 'styled-components';

import { Text } from 'components';

interface SliderProps {
  value: number;
  onChange: (value: number) => void;
  min: number;
  max: number;
  item: string;
  per: string;
  unit?: string;
  step?: number;
}

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.cultured};
  width: 100%;
  max-width: 21.4375rem;
  margin: 0 1rem;
  border-radius: 0.75rem;
  padding: 0.75rem 1.25rem;
`;

// Styled components not picking up class
const MaterialSliderStyled = withStyles({
  root: {
    color: '#2FBE8F',
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: '#2FBE8F',
    border: '2px solid currentColor',
    marginTop: -8,
    marginLeft: -12,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)',
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(MaterialSlider);

const LabelContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const MinMaxContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const Item = styled(Text)`
  margin-right: 0.2rem;
`;

const Per = styled(Text)`
  margin-right: 0.625rem;
`;

const Min = styled(Text)``;

const Max = styled(Text)``;

const Value = styled(Text)``;

const Slider: FC<SliderProps> = ({
  value,
  onChange,
  min,
  max,
  item,
  per,
  unit,
  step,
}) => (
  <Container>
    <LabelContainer>
      <Item type="body700">{item}</Item>
      <Per type="body" color="dark60">
        {per}
      </Per>
      <Value type="h3">
        {value}
        {unit}
      </Value>
    </LabelContainer>
    <MaterialSliderStyled
      min={min}
      max={max}
      value={value}
      onChange={(_, v) => onChange(v)}
      step={step}
    />
    <MinMaxContainer>
      <Min type="bodyM700" color="dark60">
        {unit}
        {min}
      </Min>
      <Max type="bodyM700" color="dark60">
        {unit}
        {max}
      </Max>
    </MinMaxContainer>
  </Container>
);

export default Slider;
